import React, { Component } from 'react';
import Registry from '../../../registry/index';

class ReceivePasswordForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formData: {
                email: ''
            },
            captchaToken: null,
            captchaError: '',
            error: '',
        };

        this.captchaRef = React.createRef();
        this.captchaWidgetId = null;

        this._onError = this._onError.bind(this);
        this._onSuccess = this._onSuccess.bind(this);
    }

    componentDidMount() {
        if (typeof window === 'undefined') return;

        let intervalId = null;

        const initCaptcha = () => {
            if (this.captchaRef.current && window.turnstile && this.captchaWidgetId === null) {
                this.captchaWidgetId = window.turnstile.render(this.captchaRef.current, {
                    sitekey: '0x4AAAAAACYQvImRXMQ5dwGT',
                    callback: (token) => {
                        this.setState({ captchaToken: token, captchaError: '' });
                    },
                    'expired-callback': () => {
                        this.setState({ captchaToken: null });
                    }
                });

                clearInterval(intervalId);
            }
        };

        intervalId = window.setInterval(initCaptcha, 100);
        this._intervalCleanup = () => clearInterval(intervalId);
    }

    componentWillUnmount() {
        if (this._intervalCleanup) this._intervalCleanup();

        if (window.turnstile && this.captchaWidgetId !== null) {
            window.turnstile.remove(this.captchaWidgetId);
        }
    }

    sendData(e) {
        e.preventDefault();

        if (!this.state.captchaToken) {
            this.setState({
                captchaError: Registry.get('locale').captcha_required
            });
            return;
        }

        let siteInterface = Registry.get('siteInterface');
        siteInterface
            .passwordRecover({
                ...this.state.formData,
                captcha: this.state.captchaToken
            })
            .then(this._onSuccess)
            .catch(this._onError);
    }

    _onSuccess(_response) {
        this.setState({
            formData: { email: '' },
            captchaToken: null,
            captchaError: '',
            error: ''
        });
        this.props.switchTab(0);
    }

    _onError(exception) {
        if (window.turnstile && this.captchaWidgetId !== null) {
            window.turnstile.reset(this.captchaWidgetId);
        }

        this.setState({
            error: exception.message,
            captchaToken: null
        });

    }

    handleChange(event) {
        this.setState({
            formData: {
                ...this.state.formData,
                [event.target.name]: event.target.value
            }
        });
    }

    render() {
        let lang = Registry.get('locale');
        let { error, formData, captchaError } = this.state;

        let disabledEnter = !formData.email;

        return (
            <div className="receive-password-form content">
                <a href="#" className="tab-back" onClick={() => this.props.switchTab(0)}>
                    {lang.receive_password}
                </a>

                <p className="text">{lang.receive_password_text}</p>

                <form onSubmit={e => this.sendData(e)}>
                    <input
                        name="email"
                        type="text"
                        placeholder={lang.nick_or_email}
                        value={formData.email}
                        onChange={e => this.handleChange(e)}
                        required
                    />

                    <div ref={this.captchaRef} style={{ margin: '10px 0' }} />

                    {captchaError && (
                        <div className="form-error" style={{ marginBottom: '10px', color: 'white' }}>
                            {captchaError}
                        </div>
                    )}

                    <button
                        className="popup-button primary"
                        disabled={disabledEnter}
                    >
                        {lang.send}
                    </button>
                </form>

                <p className="error" dangerouslySetInnerHTML={{ __html: error }} />
            </div>
        );
    }
}

export default ReceivePasswordForm;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/AnonymousLoginPopup/ReceivePasswordForm.js